
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Editor } from '@tiptap/core';
import MenuButton from '@/components/tiptap/Menu/MenuButton.vue';

@Component({
  components: {
    MenuButton,
  },
})
export default class MenuRedoButton extends Vue {
  @Prop({ required: true }) editor: Editor;
  @Prop({ default: () => {} }) command: () => void;

  runCommand() {
    this.editor.chain().redo().run();
    this.command();
  }
}
